import { API_URL } from "./api";

export type QuestionDTO = {
    id: string;
    question: string;
    image: string;
    options: OptionDTO[];
};
export type OptionDTO = {
    option: string;
    type: "Answer" | "Distractor 1" | "Distractor 2";
};

const getQuestions = async (pool: string): Promise<QuestionDTO[] | undefined> => {
    const res = await fetch(`${API_URL}/questions?pool=${pool}`).then(
        response => {
            return response.json();
        },
        err => {
            console.log(err);
        }
    );
    return res;
};

export default getQuestions;
